import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import BoostshootRowCard from '../../component/BoostshootRowCard/BoostshootRowCard'
import ServicesInnerCardsCarousel from '../../component/ServicesInnerCardsCarousel/ServicesInnerCardsCarousel'

const cardD = [
  {
    img: false,
    title: "",
    para:'Referral from family physician.',
    number:"01",
    id: 1,
  },
  {
    img: false,
    title: "",
    para:'Multidisciplinary assessment including cognitive and physical testing.',
    number:"02",
    id: 2,
  },
  {
    img: false,
    title: "",
    para:'Geriatrician prepares a care plan and sends recommendations back to the family doctor.',
    number:"03",
    id: 3,
  },
]

const cardList = [
  {
    img:"/images/creatives/team-card-img.jpg",
    name:"Audiology Referral",
    rank:"",
    para:'Screen for hearing issues contributing to cognitive decline.'
  },
  {
    img:"/images/creatives/team-2.png",
    name:"Falls Prevention Physio",
    rank:"",
    para:'Support safer mobility and reduce falls.'
  },
]

const boostCardData = [
    "Support for complex seniors with multiple conditions",
    "Cognitive screening and memory support",
    "Safer medication prescribing through expert review",
    "Shared care between specialists and primary physicians",
]

function GeriatricGHAP() {
  return (
    <div style={{backgroundColor:"#FEFCF0"}}>
         <Header/>
        <HomeHero
            heading='Geriatric Health Assessment Program (GHAP)'
            content='Comprehensive geriatric assessments to support family physicians caring for older adults.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/healthAssesmenthero-image.png"}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            btnCalnedly={true}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="Formulas for an empowered you"
            para="The Geriatric Health Assessment Program (GHAP) is an OHIP-covered service providing cognitive, physical, and medication reviews for seniors. Our team helps family doctors manage complex aging patients through coordinated recommendations from a consulting geriatrician."
            bgImg="/images/creatives/service-main-7.webp"
          />

          <div className='pt-4'></div>
          {/* <SlideScrollContent
            cardData={cardD}
            noContent={true}
          /> */}
          <BoostshootRowCard
            cards={cardD}
          />
          <div className='pb-5'></div>
        </div>

        {/* <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}> */}
        <div style={{backgroundImage:"url(/images/creatives/boost-shoot-bg.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={boostCardData}
        />

        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph=""
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
        
        </div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
    </div>
  )
}

export default GeriatricGHAP